import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layer deletAlt" }
const _hoisted_2 = { class: "layerBtnArea" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"layerTitle\">알림</div><div class=\"layerMain\"><div class=\"layerMainText\"><span class=\"bold\">스팸 방지 및 보안 규정에 따라 <span class=\"red\">해외 IP에서의 발송서비스가 제한</span> 됩니다.</span><br><span class=\"bold\">VPN 환경 또는 기타 방법으로 접속하신 경우 해당 기능을 해제 후 재접속 하시기 바랍니다.</span></div></div>", 2)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "grayBtn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.hide && $options.hide(...args)))
      }, "닫기")
    ])
  ], 512)), [
    [_vShow, $data.visible]
  ])
}